import { render, staticRenderFns } from "./PromiseCard.vue?vue&type=template&id=4d8693cc&"
import script from "./PromiseCard.vue?vue&type=script&lang=js&"
export * from "./PromiseCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports